import React from 'react';
import { useStripe } from '@stripe/stripe-react-native';
import { View, StyleSheet, Alert } from 'react-native';
import { usePaymentsContext } from '../providers/PaymentsProvider';

export interface MobilePaymentSheetProps {
  customerId?: string;
  amount: number;
  currency?: string;
  paymentIntentClientSecret?: string;
  onSuccess?: (paymentIntent: any) => void;
  onError?: (error: string) => void;
  children?: React.ReactNode;
}

export const MobilePaymentSheet: React.FC<MobilePaymentSheetProps> = ({
  customerId,
  amount,
  currency = 'usd',
  paymentIntentClientSecret,
  onSuccess,
  onError,
  children,
}) => {
  const { presentPaymentSheet, initPaymentSheet } = useStripe();
  const { initialized } = usePaymentsContext();

  const openPaymentSheet = async () => {
    if (!initialized) {
      const error = 'Payment provider not initialized';
      onError?.(error);
      return;
    }

    try {
      // Initialize the payment sheet
      if (paymentIntentClientSecret) {
        const { error } = await initPaymentSheet({
          merchantDisplayName: 'Your App Name',
          paymentIntentClientSecret,
          defaultBillingDetails: {
            name: '',
          },
          allowsDelayedPaymentMethods: true,
        });

        if (error) {
          throw new Error(error.message);
        }
      }

      // Present the payment sheet
      const { error } = await presentPaymentSheet();

      if (error) {
        if (error.code === 'Canceled') {
          // User canceled - don't show error
          return;
        }
        throw new Error(error.message);
      }

      // Payment succeeded
      onSuccess?.({ status: 'succeeded' });
    } catch (error) {
      const errorMessage =
        error instanceof Error ? error.message : 'Payment failed';
      onError?.(errorMessage);
      Alert.alert('Payment Error', errorMessage);
    }
  };

  return <View style={styles.container}>{children}</View>;
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
});

export default MobilePaymentSheet;
